/**
 * Generic service access probe — twin of the CDN-specific access hook.
 * Hits GET /api/v3/services/:id/access → { mode: "full" | "report" }.
 * Fails open to "full" so a missing or erroring probe never hides management
 * UI for a legitimately-full member.
 */
import { useQuery } from '@tanstack/react-query';
import { serviceApiV3 } from '@/api/client';

export type ServiceAccessMode = 'full' | 'report';

export function useServiceAccess(serviceId: string) {
  return useQuery({
    queryKey: ['service', serviceId, 'access'],
    enabled: !!serviceId,
    retry: false,
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<ServiceAccessMode> => {
      const res = await serviceApiV3.get<{ mode?: string }>(`/services/${serviceId}/access`);
      return res.data?.mode === 'report' ? 'report' : 'full';
    },
  });
}
